/**
 * author: Patrick Vyn Badiang
 */
import { Box, Button, SvgIcon, Typography } from "@mui/material";
import { ReactComponent as CustomSVG } from '../../assets/icons/Big_Rocket.svg';
import "./landpage.css";
import 'animate.css';

//Global Variables
import { useDirection } from "../../UtilityFunctions";
// import { useEffect, useState } from "react";


function CustomIcon(props) {
  return (
    <SvgIcon
      component={CustomSVG}
      inheritViewBox
      {...props}
      sx={{ height: "300px", width: "300px", ...props.sx }} // Add height and width for scaling
    />
  );
}

function Landingpage({ activeSection }) {


  const isActive = activeSection === "landing";


  const direction = useDirection();

  // const [isVisible, setIsVisible] = useState(true); // State to toggle visibility
  // const [animation, setAnimation] = useState("animate__backInUp"); // Initial animation

  // Handle scroll event
  // const handleScroll = () => {
  //   console.log("Scroll position:", window.scrollY);
  //   if (isVisible && window.scrollY > 10) { // Trigger after 100px scroll
  //     setAnimation("animate__backOutUp");
  //     setTimeout(() => {
  //       setIsVisible(false);
  //     }, 1000);
  //   }
  // };

  // useEffect(() => {
  //   // Attach scroll event listener
  //   window.addEventListener("scroll", handleScroll);
  //   return () => {
  //     // Cleanup on component unmount
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, [isVisible]); // Only re-attach if visibility changes

  return (
    <div className="landing-entire-page">
      <div className={`animate__animated ${
      isActive ? "animate__fadeIn" : "animate__backOutUp"
        }`} 
        >
      {/* Right Side - Icon */}

      <Box  sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "100%"}}>
          <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "end", alignItems: "center", width: "40%"}}>
          {isActive && (
            <Button
              href="https://www.ascendleadership.org/"
              target="_blank"
              rel="noopener noreferrer"
              className="logo-circle"
            >
              <CustomIcon
                  className={`animate__animated animate__backInUp`}
                  color="primary"
                  sx={{
                    height: "160px",
                    width: direction === "horizontal" ? "auto" : "30px",
                  }}
                />

              <svg className="circle-text" viewBox="0 0 200 200">
                <defs>
                  <path
                    id="circlePath"
                    d="M 100, 100 m -80, 0 a 80,80 0 1,0 160,0 a 80,80 0 1,0 -160,0"
                  />
                </defs>

                

                <text fontSize="12" fill="white">
                  <textPath href="#circlePath" startOffset="50%" textAnchor="middle">
                    Click for national website
                  </textPath>
                </text>
              </svg>
            </Button>              
              )}
          </Box>
          
          {/* Right Side - Icon */}
          <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "start",  width: direction === "horizontal" ? "50%" : "90%" , height: "100%"}}>

             {/* Renders differently based on direction */} 
             {direction === "vertical" ? (
              <Typography variant="h3" color="primary" align="center">
                Ascend at Virginia&nbsp;Tech</Typography>
                ) : (
                  <div>
                  <Typography variant="h1" color="primary" align="center">
                Ascend at Virginia&nbsp;Tech</Typography>

              <Box sx={{ height: "40px" }} />
                </div>
                  )}
          </Box>
      </Box>
      </div>
      
    </div>
  );
}


export default Landingpage;